/**
 * Roles are the application's own data, deliberately not derived from the
 * identity provider's claims, so the client models them as a plain ordered enum.
 */
export const ROLES = ['Member', 'Coordinator', 'Admin'] as const

export type Role = (typeof ROLES)[number]

export interface CurrentUser {
  id: string
  displayName: string
  email: string
  role: Role
}

const RANK: Record<Role, number> = { Member: 0, Coordinator: 1, Admin: 2 }

/** True when `role` is at least as privileged as `required`. */
export function hasAtLeast(role: Role, required: Role): boolean {
  return RANK[role] >= RANK[required]
}
